import { render } from "./ProGate.vue?vue&type=template&id=7e63da22"
import script from "./ProGate.vue?vue&type=script&lang=js"
export * from "./ProGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__